import React from 'react'

import { server } from './UrlBar.module.scss'
import { over1400 } from '~css/breakpoints.module.scss'

const Server = ({ value }) => (
  <div className={ [server, over1400].join(' ') }>
    { value }
  </div>
)

export default Server